import { ReportFeatures } from '@hcs/types';

export const MARKET_RISK_CHART_FEATURES = [ReportFeatures.MarketAnalysisChart];
